import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { ActivityBookings } from './components/ActivityBookings';
import { ActivityCalendar } from './components/ActivityCalendar';
import { ActivitySchedules } from './components/ActivitySchedules';
import { ActivityItems } from './components/ActivityItems';
import { useAuth } from '../../../../../../../../../hooks/auth';
import { ActivityInvoiceConfig } from './components/ActivityInvoiceConfig';
import { features } from '../../../../../../../../../config/features';

export const ActivityDetailsTabs = (props: BoxProps): JSX.Element => {
  const [tabIndex, setTabIndex] = useState(0);

  const { assignment: authenticatedAssignment } = useAuth();

  const showInvoiceConfigs =
    features.productsServicesEnabled &&
    authenticatedAssignment?.featureGroup.features.some((feature) =>
      [
        'ACTIVITY_BOOKING_INVOICE_CONFIG_FULL_ACCESS',
        'ACTIVITY_BOOKING_INVOICE_CONFIG_WRITE_ACCESS',
      ].includes(feature.key),
    );

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        isLazy
        onChange={handleTabChanges}
        variant="enclosed-colored"
      >
        <TabList>
          <Tab>Agenda</Tab>
          <Tab>Horários dos eventos</Tab>
          <Tab>Opcionais disponíveis</Tab>
          <Tab>Reservas</Tab>

          {showInvoiceConfigs && <Tab>Configurações fiscais</Tab>}
        </TabList>

        <TabPanels mt="4">
          <TabPanel>
            <ActivityCalendar />
          </TabPanel>

          <TabPanel>
            <ActivitySchedules />
          </TabPanel>

          <TabPanel>
            <ActivityItems />
          </TabPanel>

          <TabPanel>
            <ActivityBookings />
          </TabPanel>

          {showInvoiceConfigs && (
            <TabPanel>
              <ActivityInvoiceConfig />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
